/* eslint-disable no-nested-ternary */
import { useCallback, useEffect } from 'react';
import { Box } from '@mui/material';
import ReportFormCollapseMedications from '../report-form-collapse/ReportFormCollapseMedications';
import { MEDICATION_MODE, reportItemProgress } from '../AddNewReport.constants';
import { useStyles } from './StepTwo.styles';
import clsx from 'clsx';

const StepTwoMedications = ({
  showInterference,
  selectedItems,
  updateItems,
  lookupData,
  options,
  patientDiagnoses,
  mode = MEDICATION_MODE.ADD,
}) => {
  const classes = useStyles();

  useEffect(() => {
    updateItems(
      selectedItems.map((symp, index) => ({
        ...symp,
        progress: !index ? reportItemProgress.InProgress : reportItemProgress.Incomplete,
      })),
    );
  }, []);

  const onUpdateItem = useCallback(
    medication => {
      const nextIndex = selectedItems.findIndex(
        item =>
          item.item.value !== medication.item.value &&
          item.progress !== reportItemProgress.Completed &&
          item.notes.trim().length === 0,
      );
      updateItems(
        selectedItems.map((selectedItem, index) =>
          selectedItem.item.value === medication.item.value
            ? { ...medication, progress: reportItemProgress.InProgress }
            : index === nextIndex
            ? { ...selectedItem, progress: reportItemProgress.InProgress }
            : selectedItem,
        ),
      );
    },
    [selectedItems, updateItems],
  );

  const onOpenCollapse = medication => open => {
    let newProgress;
    if (open) {
      // When opening, set to InProgress
      newProgress = reportItemProgress.InProgress;
    } else {
      // When closing manually, set based on completion status
      newProgress = medication.notes.trim().length
        ? reportItemProgress.Completed
        : reportItemProgress.Incomplete;
    }

    updateItems(
      selectedItems.map(selectedItem =>
        selectedItem.item.value === medication.item.value
          ? { ...selectedItem, progress: newProgress }
          : selectedItem,
      ),
    );
  };

  return (
    <Box
      className={clsx(classes.container, {
        [classes.contentRefill]: mode === MEDICATION_MODE.UPDATE,
      })}
    >
      {selectedItems.map((medication, index) => (
        <ReportFormCollapseMedications
          open
          key={index}
          lookupData={lookupData}
          medication={medication}
          showInterference={showInterference}
          patientDiagnoses={patientDiagnoses}
          onChange={onUpdateItem}
          onOpenCollapse={onOpenCollapse(medication)}
          options={options}
        />
      ))}
    </Box>
  );
};

export default StepTwoMedications;
